import React from 'react';

const CarChip = ({
    removeBorder = false,
    children,
}: {
    removeBorder?: boolean;
    children: React.ReactNode;
}) => {
    return (
        <div
            className={`flex px-1.5 py-1 rounded-md ${
                !removeBorder ? 'bg-gray-50' : ''
            }`}
        >
            {children}
        </div>
    );
};

export default CarChip;
